import { configurationApi } from '../configurationApi';
import type { UploadProgress } from '../../signalRService';

// The upload is asynchronous: the 202 response only confirms the operation started and reports
// pre-processing rejections. There is no `loaded`/`removed` here - those counts arrive later on
// the SignalR completion event, once the file has actually been processed.
export interface DiagnosisUploadResponse {
  operationId: string;
  isSuccess: boolean;
  rejectedLines: number;
  errors: string[];
}

const diagnosisEndpoints = configurationApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadDiagnosisCodes: builder.mutation<DiagnosisUploadResponse, { file: File }>({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: 'DiagnosisCodes/Upload',
          method: 'POST',
          body: formData,
        };
      },
    }),
    // The load already running on the service, in the same shape the hub's progress events carry,
    // or null (204) when none is. A page that opens mid-load adopts it from here.
    getDiagnosisLoadStatus: builder.query<UploadProgress | null, void>({
      query: () => ({
        url: 'DiagnosisCodes/Upload/Status',
        responseHandler: async (response) => (response.status === 204 ? null : response.json()),
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useUploadDiagnosisCodesMutation, useGetDiagnosisLoadStatusQuery } = diagnosisEndpoints;
